export default __webpack_public_path__ + "static/media/8_StayInTheLoop.eba8725d.webp";